<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0"></app-mat-spinner-overlay>
<div class="dialog-container">
  <div class="dialog-header">
    <mat-icon>search</mat-icon>
    <h2 mat-dialog-title>Pesquisa de Frotas</h2>
    <button mat-icon-button [mat-dialog-close]="selectedItem" class="close-button" matTooltip="Fechar diálogo">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="dialog-content">
    <div class="search-form-container">
      <form autocomplete="off">
        <div class="search-form-row">
          <div class="form-fields">
            <mat-grid-list cols="4" rowHeight="100px">
              <mat-grid-tile colspan="1" rowspan="1">
                <mat-form-field>
                  <mat-label>Selecionar Por</mat-label>
                  <mat-select [(ngModel)]="filtro.coluna" name="coluna">
                    <mat-option *ngFor="let opcao of selectUm" [value]="opcao.value">
                      {{opcao.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

              </mat-grid-tile>
              <mat-grid-tile colspan="1" rowspan="1">

                <mat-form-field>
                  <mat-select [(ngModel)]="filtro.operador" name="operador">
                    <mat-option *ngFor="let opcaosec of selectDois" [value]="opcaosec.value">
                      {{opcaosec.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- <p> Selected opcao: {{selectedValueSecundaria}} </p> -->
              </mat-grid-tile>
              <mat-grid-tile colspan="1" rowspan="1">

                <mat-form-field>
                  <!-- <mat-label>Filtrar Frota</mat-label> -->
                  <input matInput placeholder="Ex. Ctf frota #" [(ngModel)]="filtro.parametro"
                    [value]="filtro.parametro">
                  <!-- <mat-icon matIconSuffix>search</mat-icon> -->
                  <mat-icon (click)="limpaFiltro()" aria-hidden="false"
                    aria-label="Limpe o resultado da pesquisa de Frota" fontIcon="delete">
                  </mat-icon>
                </mat-form-field>
              </mat-grid-tile>
              <mat-grid-tile colspan="1" rowspan="1">

                <button mat-flat-button color="accent" type="button" (click)="getFrota()"
                  [disabled]='filtro.parametro == ""' mat-icon-button style="margin-left: 10px"
                  matTooltip="Pesquise a Frota">
                  <mat-icon aria-hidden="false" aria-label="Pesquise a Frota" fontIcon="search"></mat-icon>
                </button>

              </mat-grid-tile>
            </mat-grid-list>
          </div>
        </div>
      </form>
    </div>

    <div>
      <h4><strong>Selecione abaixo a frota desejada</strong></h4>
      <mat-table [dataSource]="items" matSort matSortActive="codigo">

        <ng-container matColumnDef="codigo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por código">
            Código
          </th>
          <td mat-cell *matCellDef="let element">{{element.codigo}}</td>
        </ng-container>

        <ng-container matColumnDef="nomeReduzido">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por nome fantasia">
            Fantasia
          </th>
          <td mat-cell *matCellDef="let element">{{element.nomeReduzido.trim()}}</td>
        </ng-container>

        <ng-container matColumnDef="descricao">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por nome razão social">
            Razão Social
          </th>
          <td mat-cell *matCellDef="let element">{{element.descricao.trim()}}</td>
        </ng-container>

        <ng-container matColumnDef="municipio">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por municipio">
            Cidade
          </th>
          <td mat-cell *matCellDef="let element">{{element.municipio.trim()}}</td>
        </ng-container>

        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por estado">
            UF
          </th>
          <td mat-cell *matCellDef="let element">{{element.estado.trim()}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row (click)="gerenciarSelect(row)" *matRowDef="let row; columns: displayedColumns; let even = even"
          class="table-row"></tr>
      </mat-table>

      <tr class="no-data" *ngIf="items.data.length == 0 && loading == 0">
        <td colspan="3" style="text-align: center; font-weight: bold;">
          Nenhuma frota encontrada!
        </td>
      </tr>

            <tr class="no-data" *ngIf="loading > 0">
              <td colspan="3" style="text-align: center; font-weight: bold;">
                Aguarde, consultando frotas...
              </td>
            </tr>


    </div>
    <div>
      <div class="paginator-centre">
        <mat-paginator [pageSizeOptions]="[5, 50, 100, 1000]" showFirstLastButtons class="mat-elevation-z8"
          aria-label="Selecione a página de frotas">
        </mat-paginator>
      </div>
    </div>
  </div>


</div>
